module.exports = __webpack_public_path__ + "static/img/02.9562153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/02.png
// module id = ViCQ
// module chunks = 1